export type DisplaySession = '2023 Regular Session' | '2024 Regular Session' | '2025 Regular Session'
export type APISession = '2023RS' | '2024RS' | '2025RS'

export const AVAILABLE_SESSIONS: DisplaySession[] = [
    '2023 Regular Session',
    '2024 Regular Session',
    '2025 Regular Session'
]

export const displayToAPISession = (displaySession: DisplaySession): APISession => {
    const year = displaySession.substring(0, 4)
    if (year === '2023') return '2023RS'
    if (year === '2024') return '2024RS'
    return '2025RS'
}

export const apiToDisplaySession = (apiSession: APISession): DisplaySession => {
    const year = apiSession.substring(0, 4)
    if (year === '2023') return '2023 Regular Session'
    if (year === '2024') return '2024 Regular Session'
    return '2025 Regular Session'
}

export const isValidSession = (session: string): session is DisplaySession => {
    return AVAILABLE_SESSIONS.includes(session as DisplaySession)
}

export const isValidAPISession = (session: string): session is APISession => {
    return session === '2023RS' ||
        session === '2024RS' ||
        session === '2025RS'
}